export const FETCH_PRODUCTS_DATA = 'products/FETCH_DATA';
export const FETCH_LICENSES_DATA = 'licenses/FETCH_DATA';

export const CREATE_PRODUCT = 'create-product';
export const UPDATE_PRODUCT = 'update-product';
export const DELETE_PRODUCT = 'delete-product';

export const CREATE_LICENSE = 'create-license';
export const UPDATE_LICENSE = 'update-license';
export const DELETE_LICENSE = 'delete-license';

export const SELECT_APPLICATION_ACCESS_LICENSE = 'SELECT_APPLICATION_ACCESS_LICENSE';

export const ASSIGN_LICENSE = 'assign-license';
export const REMOVE_LICENSE_FROM_CUSTOMER = 'licenses/REMOVE_LICENSE_FROM_CUSTOMER';
export const EDIT_ASSIGNED_LICENSE = 'license/EDIT_ASSIGNED_LICENSE';

export const GET_LICENSE_ROLES = 'license/GET_ROLES';

export const GET_USERS_FOR_LICENSE = 'license/GET_USERS_FOR_LICENSE';
export const ASSIGN_USER_TO_LICENSE = 'license/ASSIGN_USER';
export const UN_ASSIGN_USER_FROM_LICENSE = 'license/UN_ASSIGN_USER';
